/**
 * Foodstand React Native App
 * https://github.com/facebook/react-native
 * @flow
 */

//import BASE_FONT from "react-native-vector-icons/Fonts/FontAwesome.ttf"
//var fontFile = "/assets/fonts/hope/Hope.ttf"

//See: https://github.com/tdzl2003/react-native-web-platform/issues/3
require('regenerator-runtime/runtime');
require('es6-promise').polyfill();

import { View } from "react-native"
import FSIconFont from "app/assets/fonts/FSIcon/FSIcon.woff"
import { AppRegistry } from "react-native"
import App from './app/views/App'

// inject stylesheet for custom font
function injectFont(fontName, fontFile) {
  const reactNativeVectorIconsRequiredStyles =
    "@font-face {  font-family: "+fontName+"; src: url(" + fontFile + "); format('font-woff'); }"
  const style = document.createElement("style")
  style.type = "text/css"
  if (style.styleSheet) {
    style.styleSheet.cssText = reactNativeVectorIconsRequiredStyles
  } else {
    style.appendChild(document.createTextNode(reactNativeVectorIconsRequiredStyles))
  }
  document.head.appendChild(style)
}

injectFont("FSIcon", FSIconFont)

// Sets up offline caching for all assets (disabled by default)
// You can enable offline caching by changing
// `enableOfflinePlugin` at the top of web/webpack.config.js
if (__OFFLINE__) {
  require("offline-plugin/runtime").install()
}

AppRegistry.registerComponent("Foodstand", () => App)
var el = window.document.getElementById("react-foodstand-root")

const urlParams = new URLSearchParams(window.location.search);
AppRegistry.runApplication("Foodstand", {
  rootTag: el,
  initialProps: {
    initialChallengeId: urlParams.get("initialChallengeId") ? parseInt(urlParams.get("initialChallengeId")) : null,
    initialChallengeDifficultyId: urlParams.get("initialChallengeDifficultyId") ? parseInt(urlParams.get("initialChallengeDifficultyId")) : null,
  },
})
